// extracted by mini-css-extract-plugin
export default {"svgHeightWidth":"IconBadge__svgHeightWidth___6VCOv"};